import Pagination from './Pagination'
import DetailList from './DetaiList'
import Divider from './Divider'
import Uploader from './Uploader'
import Confirm from './Confirm'
import DownLoadImg from './DownLoadImg'
import Link from './Link'
import ProductSelect from './Product/select'
import SpecialPageSelect from './SpecialPage/select'
import instructionsProductSelect from './Product/instructions-select'
import ec from './ec'
import ImportExport from "@/components/ImportExport";
import badge from '@/components/Badge'
import UploaderOss from './UploaderOss'

// export global component here {'name' => Component}

export default {
  pagination: Pagination,
  'detail-list': DetailList,
  'detail-list-item': DetailList.Item,
  divider: Divider,
  uploader: Uploader,
  confirm: Confirm,
  'download-img': DownLoadImg,
  'ec-link': Link,
  'ec-product-select': ProductSelect,
  'ec-special-page-select': SpecialPageSelect,
  'ec-instructions-product-select': instructionsProductSelect,
  ...ec,
  ImportExport,
  badge,
  'uploader-oss':UploaderOss
}
